import recommend from '@algolia/recommend';
import { globals } from './globals';
import { createFallbackableCache } from '@algolia/cache-common';
import { version } from '@algolia/client-common';
import { createInMemoryCache } from '@algolia/cache-in-memory';
import { createBrowserLocalStorageCache } from '@algolia/cache-browser-local-storage';

let singletonClient: ReturnType<typeof recommend> | null = null;
let clientAppId: string | undefined;
let clientApiKey: string | undefined;

export function getRecommendClient(): ReturnType<typeof recommend> {
  const appId = globals.algoliaAppId;
  const apiKey = globals.algoliaSearchKey;

  if (singletonClient && clientAppId === appId && clientApiKey === apiKey) {
    return singletonClient;
  }

  singletonClient = recommend(appId, apiKey, {
    hostsCache: createFallbackableCache({
      caches: [createBrowserLocalStorageCache({ key: `${version}-${appId}` }), createInMemoryCache()],
    }), // or createNullCache(), createInMemoryCache()
  });
  clientAppId = appId;
  clientApiKey = apiKey;

  return singletonClient;
}

export function _resetForTesting(): void {
  singletonClient = null;
  clientAppId = undefined;
  clientApiKey = undefined;
}
